import { useTranslation } from 'react-i18next'
import { DateRange, DateRangePicker as RsDateRangePicker } from 'rsuite'
import './index.css'
import { isAfter } from 'date-fns'

type Props = {
  value: DateRange | null
  maxDate: Date
  onChange: (dates: DateRange) => void
  onClose?: () => void
  placeholder?: string
  character?: string
}

export default function DateRangePicker(props: Props) {
  const texts = useTranslation('common').t

  return (
    <RsDateRangePicker
      value={props.value}
      shouldDisableDate={(date) => isAfter(date, props.maxDate)}
      showOneCalendar
      onChange={(dates) => {
        props.onChange(dates!)
      }}
      onClose={props.onClose}
      placeholder={texts('date_range_placeholder')}
      character={texts('date_range_middle_label')}
      size='lg'
    />
  )
}
